import { render, staticRenderFns } from "./index.pc.vue?vue&type=template&id=0238e23f&scoped=true"
import script from "./index.pc.vue?vue&type=script&lang=js"
export * from "./index.pc.vue?vue&type=script&lang=js"
import style0 from "./index.pc.vue?vue&type=style&index=0&id=0238e23f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0238e23f",
  null
  
)

export default component.exports